import { render, staticRenderFns } from "./demandList.vue?vue&type=template&id=5317ebc1"
import script from "./demandList.vue?vue&type=script&lang=js"
export * from "./demandList.vue?vue&type=script&lang=js"
import style0 from "./demandList.vue?vue&type=style&index=0&id=5317ebc1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports